<div class="flex flex-col gap-6">
  @if (formArray().controls.length) {
    @let isSingle = visibleExecutionCount < 2;
    <div class="flex flex-col gap-3">
      @for (control of formArray().controls; track control.value.id ?? $index) {
        @if (
          !control.value.exclusiveTo || isViewMode() || (isCustomMode() && control.value.exclusiveTo === creatorId())
        ) {
          <div
            class="transition-colors duration-300 rounded-lg -mx-3 px-3 -my-1 py-1"
            [class.bg-shikenso-pink-base-12]="isNewlyAddedExecution(control.value.id ?? '')"
            [attr.data-element-id]="control.value.id ?? ''"
          >
            <app-execution
              [isSingleExecution]="isSingle"
              [form]="control"
              [executionNumber]="getExecutionNumber($index)"
              [platformFeature]="platformFeature()"
              [availableKpis]="availableKpis()"
              [creatorId]="creatorId()"
              [ctaTemplateId]="ctaTemplateId()"
              [isCustomMode]="isCustomMode()"
              [isParentDeleteDisabled]="isParentDeleteDisabled()"
              [lastActiveElementDetails]="lastActiveElementDetails()"
              [creators]="creators()"
              [isExpanded]="isAllExpanded()"
              [isViewMode]="isViewMode()"
              [gamePlayValues]="gamePlayValues()"
              (delete)="removeExecution($index)"
              (parentCheckboxChange)="checkParentDeleteDisabled()"
              (executionDeleteCheckboxChange)="executionDeleteCheckboxChange.emit($event)"
            />
          </div>
        }
      }
    </div>
  }

  @if (!isViewMode()) {
    <div class="flex justify-start">
      <button mat-flat-button color="secondary-transparent" (click)="addExecution()">
        <div class="flex items-center gap-2 text-shikenso-purple-base-40">
          <app-icon src="/icons/plus.svg" alt="plus" color="currentColor" [size]="16" />
          <span>
            {{ 'pages.campaignForm.ctaDialog.ctaDetails.executions.addAnotherFrequencyRule' | translate }}
          </span>
        </div>
      </button>
    </div>
  }
</div>
